// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"oo-z","slideIn":"po-z"};